module.exports = __webpack_public_path__ + "img/feather-download.svg";